<template>
  <div class="facetranges" v-if="ordered_facets">

  <div v-for="(wrapper) in this.facetsToShow">

    <FacetRangeSlider v-if="wrapper.type=='slider'"
      v-bind:facetname="wrapper.key" v-bind:facet="ordered_facets[wrapper.key]" :key="wrapper.key+'slider'"></FacetRangeSlider>

    <FacetRange v-if="wrapper.type=='list'"
      v-bind:facetname="wrapper.key" v-bind:facet="ordered_facets[wrapper.key]" :key="wrapper.key"></FacetRange>

    <DateHistogramSlider v-bind:facetname="wrapper.key" v-if="wrapper.type=='histogram'"></DateHistogramSlider>

  </div>
  </div>
</template>

<script>
import FacetRangeChart from './FacetRangeChart'
import FacetRange from './FacetRange'
import FacetRangeSlider from './FacetRangeSlider'
import DateHistogramSlider from './DateHistogramSlider'

export default {
  name: 'facetranges',
  data () {
    return {
      selected: null,
      facetsToShow: [
            { 'key': 'Technology_Readiness_Level__All', 'type': 'slider' },
            { 'key': 'Technology_Readiness_Level__Prerequisite', 'type': 'slider' },
            { 'key': 'Technology_Readiness_Level__Target', 'type': 'slider' },
            { 'key': 'Budget_Total', 'type': 'list' },
            { 'key': 'Opening_Dates', 'type': 'histogram' },
            { 'key': 'Publication_Date', 'type': 'list' }
          ]
    }
  },
  components: {
    FacetRangeChart,
    FacetRange,
    FacetRangeSlider,
    DateHistogramSlider
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    facets () {
      if (this.$store.state.response &&
          this.$store.state.response.facet_counts &&
          this.$store.state.response.facet_counts.facet_ranges) {
        return this.$store.state.response.facet_counts.facet_ranges
      }
      return null;
    },
    ordered_facets() {
      var facetSort = [
            'Technology_Readiness_Level__All',
            'Technology_Readiness_Level__Prerequisite',
            'Technology_Readiness_Level__Target',
            'Budget_Total',
            'Deadlines',
            'Publication_Date',
          ]

      if (this.$store.state.response &&
          this.$store.state.response.facet_counts &&
          this.$store.state.response.facet_counts.facet_ranges) {

          return Object.keys(this.$store.state.response.facet_counts.facet_ranges).sort(
            function(x, y) {
              return facetSort.indexOf(x) - facetSort.indexOf(y)
            }
          ).reduce((r, k) => (r[k] =  this.$store.state.response.facet_counts.facet_ranges[k], r), {});

        }
    }
  }
}
</script>

<style scoped>
</style>
